import * as React from 'react';
import Text from 'components/Text';
import Image from 'components/Image';
import Link from 'components/Link';
import Badge from 'components/Badge';

import './styles/NavigationItem.scss';

export type NavigationItemProps = {
  image?: string;
  title: string;
  unreadCount: number;
  to: string;
};

export const NavigationItem = ({ image, title, unreadCount, to }: NavigationItemProps) => {
  return (
    <li className="NavigationItem">
      <Link color="inherit" to={to} activeClassName="active">
        <div className="NavigationItem-content">
          {image ? (
            <Image width={16} height={16} src={image} />
          ) : (
            <div className="NavigationItem-placeholder" />
          )}

          <Text weight={unreadCount > 0 ? 'semibold' : 'normal'} truncate>
            {title}
          </Text>

          {unreadCount > 0 && (
            <Badge data-testid="badge" count={unreadCount} color="apple" size="medium" />
          )}
        </div>
      </Link>
    </li>
  );
};
